export const articleChevronColours: {[key: string]: string} = {
  teal: "rgba(5, 55, 71, 1)",
  aqua: "rgba(34, 195, 187, 1)",
  "deep-red": "rgba(185, 10, 103, 1)",
  "deep-blue": "rgba(34, 108, 166, 1)",
  "light-green": "rgba(175, 202, 10, 1)",
  "deep-purple": "rgba(124, 78, 195, 1)",
  "light-blue": "rgba(132, 201, 240, 1)",
  red: "rgba(232, 60, 78, 1)",
  "deep-green": "rgba(0, 131, 117, 1)",
  yellow: "rgba(254, 205, 33, 1)",
  pink: "rgba(237, 109, 180, 1)",
  turquoise: "rgba(0, 173, 194, 1)",
  orange: "rgba(255, 152, 35, 1)",
  graphite: "rgba(89, 88, 88, 1)",
  "mid-grey": "rgba(125, 127, 128, 1)",
  silver: "rgba(200, 200, 199, 1)",
  "light-grey": "rgba(233, 233, 233, 1)",
}

export const articleTitleBackgroundColours: {[key: string]: string} = {
  teal: "rgba(5, 55, 71, 0.85)",
  aqua: "rgba(34, 195, 187, 0.85)",
  "deep-red": "rgba(185, 10, 103, 0.85)",
  "deep-blue": "rgba(34, 108, 166, 0.85)",
  "light-green": "rgba(175, 202, 10, 0.85)",
  "deep-purple": "rgba(124, 78, 195, 0.85)",
  "light-blue": "rgba(132, 201, 240, 0.85)",
  red: "rgba(232, 60, 78, 0.85)",
  "deep-green": "rgba(0, 131, 117, 0.85)",
  yellow: "rgba(254, 205, 33, 0.85)",
  pink: "rgba(237, 109, 180, 0.85)",
  turquoise: "rgba(0, 173, 194, 0.85)",
  orange: "rgba(255, 152, 35, 0.85)",
  graphite: "rgba(89, 88, 88, 0.85)",
  "mid-grey": "rgba(125, 127, 128, 0.85)",
  silver: "rgba(200, 200, 199, 0.85)",
  "light-grey": "rgba(233, 233, 233, 0.85)",
}

export const articleTitleTextColours: {[key: string]: string} = {
  teal: "#ffffff",
  aqua: "#ffffff",
  "deep-red": "#ffffff",
  "deep-blue": "#ffffff",
  "light-green": "#ffffff",
  "deep-purple": "#ffffff",
  "light-blue": "#ffffff",
  red: "#ffffff",
  "deep-green": "#ffffff",
  yellow: "#053747",
  pink: "#ffffff",
  turquoise: "#ffffff",
  orange: "#ffffff",
  graphite: "#ffffff",
  "mid-grey": "#ffffff",
  silver: "#053747",
  "light-grey": "#053747",
}
